export const deficitsNav = [
  { path: '/deficits', label: 'Add Deficits' },
  { path: '/deficits/report', label: 'Report' },
];
